<div class="mod mod-modal" [class.is-open]="isVisible">
    <div class="mod-modal__dialog mod-modal__dialog--large">
        <div class="mod-modal__content">
            <div class="zas-esign-row" style="background: white; color: black">
                <div class="panel">
                    <div class="panel-heading">
                        Vermittlerdaten über Producercode befüllen
                        <span
                            *ngIf="loading"
                            class="icon-loop spinning waiting"
                        ></span>
                    </div>
                    <div class="panel-body">
                        <input
                            type="text"
                            id="producercode"
                            class="form-control"
                            placeholder="Producercode"
                            [(ngModel)]="producerCode"
                            (input)="load()"
                        />
                        <ul class="results" style="min-width: 695px">
                            <li
                                *ngFor="
                                    let record of records$
                                        | async
                                        | slice: 0 : 100;
                                    index as i
                                "
                                (click)="toggle(i)"
                            >
                                <span class="result-item">
                                    <span
                                        [ngClass]="{
                                            'icon-icon-cta-down':
                                                toggledRecord === i,
                                            'icon-icon-cta':
                                                toggledRecord !== i,
                                        }"
                                    ></span>
                                    &nbsp;{{ record.ProducerCode }},
                                    {{ record.LastName }} {{ record.FirstName }}
                                </span>
                                <div
                                    style="padding: 20px"
                                    *ngIf="toggledRecord === i"
                                >
                                    <table class="table">
                                        <tr>
                                            <td>Agenturnummer:</td>
                                            <td>{{ record.AgencyNumber }}</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>Strasse:</td>
                                            <td>{{ record.Street }}</td>
                                            <td>PLZ:</td>
                                            <td>{{ record.ZIP }}</td>
                                        </tr>
                                        <tr>
                                            <td>Ort:</td>
                                            <td>{{ record.City }}</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>Telefon geschäftlich:</td>
                                            <td>{{ record.Phone }}</td>
                                            <td>Telefon mobil:</td>
                                            <td>{{ record.Mobile }}</td>
                                        </tr>
                                        <tr>
                                            <td>Telefax:</td>
                                            <td>{{ record.Fax }}</td>
                                            <td>E-Mail:</td>
                                            <td>{{ record.Email }}</td>
                                        </tr>
                                    </table>
                                    <button
                                        class="zas-button"
                                        (click)="select(record)"
                                    >
                                        Auswählen
                                    </button>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="mod-modal__footer">
            <button class="zas-button" (click)="close()">Abbrechen</button>
        </div>
    </div>
</div>
